import {
  OVERVIEW_ACTIVE,
  OVERVIEW_INACTIVE,
  FOLDER_ACTIVE,
  FOLDER_INACTIVE,
  REQUEST_ACTIVE,
  REQUEST_INACTIVE,
  PAYMENT_ACTIVE,
  PAYMENT_INACTIVE,
  NOTIFICATION_ACTIVE,
  NOTIFICATION_INACTIVE,
  SETTING_ACTIVE,
  SETTING_INACTIVE,
  FILE_SEARCH_ACTIVE,
  FILE_SEARCH_INACTIVE,
} from "../../../../assets";

export const Registrar2SidebarRoute = [
  {
    title: "Overview",
    activeIcon: OVERVIEW_ACTIVE,
    inactiveIcon: OVERVIEW_INACTIVE,
    path: "/registrar2/overview",
  },
  {
    title: "Case Folders",
    activeIcon: FOLDER_ACTIVE,
    inactiveIcon: FOLDER_INACTIVE,
    path: "/registrar2/case-folders",
  },
  {
    title: "Assigned Appeal No",
    activeIcon: REQUEST_ACTIVE,
    inactiveIcon: REQUEST_INACTIVE,
    path: "/registrar2/assigned-appeal",
  },
  {
    title: "Joinder Request",
    activeIcon: REQUEST_ACTIVE,
    inactiveIcon: REQUEST_INACTIVE,
    path: "/registrar2/joinder-request",
  },
  {
    title: "Search Assigned Cases",
    activeIcon: FILE_SEARCH_ACTIVE,
    inactiveIcon: FILE_SEARCH_INACTIVE,
    path: "/registrar2/search-assigned-appeal",
  },
  {
    title: "Payment history",
    activeIcon: PAYMENT_ACTIVE,
    inactiveIcon: PAYMENT_INACTIVE,
    path: "/registrar2/payment-history",
  },
  {
    title: "Notification",
    activeIcon: NOTIFICATION_ACTIVE,
    inactiveIcon: NOTIFICATION_INACTIVE,
    path: "/registrar2/notification",
  },
  {
    title: "Setting",
    activeIcon: SETTING_ACTIVE,
    inactiveIcon: SETTING_INACTIVE,
    path: "/registrar2/setting",
  },
];
